var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from "vue-facing-decorator";
import { ReportScheduleModel, ReportClient, ReportTypeEnum, CreateReportScheduleCommand, UpdateReportScheduleCommand } from "@/app/api/battery-portal-api";
import ContactsVue from "@/app/vues/components/contacts.vue";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { Notifier } from "@/common/utils/notifier";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const reportClient = new ReportClient(window.apiUrl);
let ReportManagerVue = class ReportManagerVue extends Vue {
    constructor() {
        super(...arguments);
        this.maxBodyLength = 5000;
        this.startDate = new Date();
        this.model = new ReportScheduleModel({
            start: new Date()
        });
        this.showModal = false;
        this.canSchedule = false;
        this.showEmailDetails = false;
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig(true);
        this.reportFormats = [
            { text: "PDF", value: 0 },
            { text: "CSV", value: 1 },
            { text: "Both", value: 2 },
        ];
    }
    getBodyLength(notes) {
        return notes ? notes.length : 0;
    }
    show(item, canSchedule) {
        var _a, _b, _c;
        this.model.id = item.id;
        this.model.reportId = item.reportId;
        this.model.description = item.description;
        this.model.subject = item.subject;
        this.model.body = item.body;
        this.model.start = item.start;
        this.model.reportFormatType = item.reportFormatType;
        this.model.period = item.period;
        this.model.dayOfTheWeek = item.dayOfTheWeek;
        this.model.query = item.query;
        this.model.contactIds = item.contactIds || new Array();
        this.model.contactGroupIds = item.contactGroupIds || new Array();
        this.model.reportType = item.reportType;
        this.startDate = item.start;
        if (item.id) {
            this.setFieldValue("description", item.description);
            this.setFieldValue("subject", (_a = item.subject) !== null && _a !== void 0 ? _a : "");
            this.setFieldValue("body", (_b = item.body) !== null && _b !== void 0 ? _b : "");
            this.setFieldValue("fileName", (_c = item.reportFileName) !== null && _c !== void 0 ? _c : "");
        }
        else {
            this.model.reportFormatType = 0;
            this.resetForm();
        }
        this.canSchedule = canSchedule;
        this.showModal = true;
        this.showEmailDetails = item.subject || item.body;
    }
    save() {
        var _a, _b, _c;
        if ((((_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.contactIds) === null || _b === void 0 ? void 0 : _b.length) || 0) <= 0 && (((_c = this.model.contactGroupIds) === null || _c === void 0 ? void 0 : _c.length) || 0) <= 0) {
            Notifier.onWarning("Select at least one Contact or Contact Group in the list!");
            return;
        }
        const handleSubmitAction = this.handleSubmit(() => {
            this.model.start = DateHelper.convertToDate(this.startDate.toString());
            let promise = () => {
                return this.model.id ?
                    reportClient.updateScheduledReport(this.model.id, new UpdateReportScheduleCommand({ requestModel: this.model })) :
                    reportClient.createScheduledReport(new CreateReportScheduleCommand({ requestModel: this.model }));
            };
            promise()
                .then(response => {
                this.showModal = false;
                this.$emit('updateScheduleList');
                if (!this.model.id)
                    this.$emit('updateCount', this.model.reportId, 1);
                Notifier.onOk();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            });
        }, (ctx) => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    cancel() {
        this.showModal = false;
        this.resetForm();
    }
    get reportFormat() {
        return this.reportFormats.filter(item => {
            return item.value == this.model.reportFormatType;
        })[0] || null;
    }
    ;
    set reportFormat(item) {
        if (!item)
            return;
        this.model.reportFormatType = item.value;
    }
    ;
    get hasReportFormats() {
        var reportsWithNoCSV = [ReportTypeEnum.OhmicTrend, ReportTypeEnum.Discharge, ReportTypeEnum.AssurePlus];
        return reportsWithNoCSV.includes(this.model.reportType) == false;
    }
};
ReportManagerVue = __decorate([
    Component({
        name: "ReportSchedulerWizardVue",
        expose: ["show"],
        emits: ["updateCount", "updateScheduleList"],
        components: {
            ContactsVue,
        },
        setup() {
            const invalidFileNameCharsRegex = /[<>:"/\\|?*\x00-\x1f]/;
            const { errors, handleSubmit, defineInputBinds, defineComponentBinds, setFieldValue, resetForm } = useForm({
                validationSchema: yup.object({
                    description: yup.string().trim().max(150).required(),
                    subject: yup.string().trim().max(150),
                    body: yup.string().trim().max(5000),
                    fileName: yup.string().trim().max(150).test('valid-filename', 'File name contains invalid characters (< > : " / \\ | ? *)', (value) => {
                        if (!value || value.length === 0)
                            return true;
                        return !invalidFileNameCharsRegex.test(value);
                    }),
                })
            });
            const descriptionVal = defineInputBinds('description');
            const subjectVal = defineInputBinds('subject');
            const bodyVal = defineInputBinds('body');
            const fileNameVal = defineInputBinds('fileName');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                resetForm,
                descriptionVal,
                subjectVal,
                bodyVal,
                fileNameVal
            };
        }
    })
], ReportManagerVue);
export default ReportManagerVue;
